import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";

export default makeStyles(theme => ({
  logotype: {
    color: "#000000",
    // marginLeft: theme.spacing(2.5),
      marginInlineStart:"3.5rem",
    marginInlineEnd: theme.spacing(2.5),
    fontWeight: 500,
    fontSize: 18,
     whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    [theme.breakpoints.down("md")]: {
      marginInlineStart:"4rem",
    },
    [theme.breakpoints.down("xs")]: {
      // display: "none",
      color: "#ffffff",
      fontSize: "12px!important",
      position: "absolute",
      insetInlineStart: 0,
      top: "2px",
      gap: "0.25rem",
      marginInlineStart:"2rem",
    },
  },
  appBar: {
    width: "100vw",
    zIndex: theme.zIndex.drawer + 1,
    // paddingRight:"10px !important",
    transition: theme.transitions.create(["margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
      //color:"#4e80c5",
    }),
    insetInlineStart: 0,
  },
  modeClass:{
    border:"groove",
    'border-radius':"5px",
    borderWidth:"2px"
  },

  select:{
    paddingInlineEnd:"0px",
    margin: "0 2px",
  },
toolbar: {
    paddingInlineStart: theme.spacing(2),
    paddingInlineEnd: theme.spacing(2),
    backgroundColor: "white",
    [theme.breakpoints.down("md")]: {
      height: "82px",
      alignItems: "end",
      paddingBottom: "0.5rem",
      paddingInline: "0.5rem"
    },
    [theme.breakpoints.down("xs")]: {
      height: "70px",
      backgroundColor: "#526cfe"
    }
  },
  hide: {
    display: "none",
  },
  grow: {
    flexGrow: 1,
  },
  search: {
    position: "relative",
    borderRadius: 25,
    paddingInlineStart: theme.spacing(2.5),
    width: 36,
    backgroundColor: alpha(theme.palette.common.black, 0),
    transition: theme.transitions.create(["background-color", "width"]),
    "&:hover": {
      cursor: "pointer",
      backgroundColor: alpha(theme.palette.common.black, 0.08),
    },
  },
  searchFocused: {
    backgroundColor: alpha(theme.palette.common.black, 0.08),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: 250,
    },
  },
 searchIcon: {
    width: 36,
    insetInlineEnd: 0,
    height: "100%",
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: theme.transitions.create("right"),
    "&:hover": {
      cursor: "pointer",
    },
  },
  searchIconOpened: {
    insetInlineEnd: theme.spacing(1.25),
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  inputInput: {
    height: 36,
    padding: 0,
    paddingInlineEnd: 36 + theme.spacing(1.25),
    width: "100%",
  },
  messageContent: {
    display: "flex",
    flexDirection: "column",
  },
  headerMenu: {
    marginTop: theme.spacing(7),
  },
  headerMenuList: {
    display: "flex",
    flexDirection: "column",
  },
  headerMenuItem: {
    "&:hover, &:focus": {
      backgroundColor: theme.palette.primary.main,
      color: "white",
    },
  },
  headerMenuButton: {
    padding: 0,
  },
  headerMenuButtonCollapse: {
    marginInlineEnd: theme.spacing(2),
  },
  headerIcon: {
    // fontSize: 28,
    color: "#0c82da",
    fontSize: "2.1875rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "1.75rem"
    },
    [theme.breakpoints.down("xs")]: {
      color: "#ffffff"
    },
  },
  headerDisableIcon: {
    // fontSize: 28,
    color: "#cccccc",
    fontSize: "2.1875rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "1.75rem"
    },
  },
  headerIconCollapse: {
    color: "#4e80c5",
  },
    queueCountCircleParent: {
    position: "absolute",
    display: "inline-flex",
    cursor: "pointer",
    top: "18px",
    insetInlineStart: "9px",
    [theme.breakpoints.down("md")]: {
      top: "12px",
      insetInlineStart: "5px",
    },
    [theme.breakpoints.down("xs")]: {
      top: "12px",
    },
  },
  queueCountCircleProgree: {
    [theme.breakpoints.down("md")]: {
    color: "transparent"
  }
  },
  queueCountNum: {
    color: "black",
    [theme.breakpoints.down("xs")]: {
      color: "#ffffff"
    },
  },
  profileMenu: {
    minWidth: 223,
    minHeight:114,
  },
  profileMenuUser: {
    display: "flex",
    // paddingLeft:"21px",
    padding:"9px 0px 9px 0px",
    // padding: theme.spacing(2),
    fontSize:"1rem",
    alignItems: "center",
  },
  profileMenuItem: {
    color: theme.palette.text.hint,
  },
  profileMenuIcon: {
    marginInlineEnd: theme.spacing(2),
    // color: theme.palette.text.hint,
    color:"black",
  },
  profileMenuLink: {
    fontSize: 16,
    paddingInlineStart:"21px",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
  messageNotification: {
    height: "auto",
    display: "flex",
    alignItems: "center",
    "&:hover, &:focus": {
      backgroundColor: theme.palette.background.light,
    },
  },
    headerTimeParent: {
    display:"flex",
    alignItems:"center",
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      top: "4px",
      fontSize: "12px",
      width: "100%",
      insetInlineStart: "0",
      justifyContent: "flex-end"
    },
  },

  timeIcon:{
    color:"lightgray", 
    marginInlineEnd:"5px",
    display:"flex",
  },
  timeIconSvg: {
    [theme.breakpoints.down("xs")]: {
      fontSize: "1rem"
    },
  },
   time:{
    color:"black",
    marginInlineEnd:"10px",
    [theme.breakpoints.down("xs")]: {
      color: "#ffffff"
    },
  },
  
  messageNotificationSide: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginInlineEnd: theme.spacing(2),
  },
  messageNotificationBodySide: {
    alignItems: "flex-start",
    marginInlineEnd: 0,
  },
  sendMessageButton: {
    margin: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textTransform: "none",
  },
  sendButtonIcon: {
    marginInlineStart: theme.spacing(2),
  },
  MuiTooltip: {
    tooltip: {
      position:"absolute",
      insetInlineEnd:"1px",
      fontSize: "1em",
      color: "black",
      backgroundColor: "white",
      border:"thin",
      boxShadow:"0px 0px 4px rgba(0,0,0,0.5)"
      }
    },
    ProfileName:{
      color:"black",
      maxWidth:"70px",
      overflow:"hidden",
      whiteSpace:"nowrap",
      textOverflow:"ellipsis"
    },
    menuFlags:{
      color:"black",
      marginInlineEnd:"10px",
      width:"180px",
    },
    ButtonRedial: {
    height: '36px',
    color: '#63b500!important',
    border: '1px solid #63b500 !important',
    textTransform: 'upparcase',
    marginInlineEnd: '20px',
    '&:hover': {
      backgroundColor: '#63b500 !important',
      color: 'white !important',
      border: '1px solid #63b500 !important'
    },
  },
  ButtonDisconnect: {
    height: '36px',
    color: '#db2c2a!important',
    border: '1px solid #db2c2a !important',
    textTransform: 'upparcase',
    marginInlineEnd: '20px',
    '&:hover': {
      backgroundColor: '#db2c2a !important',
      color: 'white !important',
      border: '1px solid #db2c2a !important'
    },
  },
  ConferenceButton: {
    marginInlineStart: '10px',
    height: '36px',
    border: '2px solid #0c82da',
    borderRadius: '50px',
    width: '130px',
    paddingInlineStart: '10px',
    paddingTop: '6px',
    backgroundColor: '#ffffff!important',
    '&:before, &:after': {
      borderBottom: 'none!important',
    },
    '& $select': {
      backgroundColor: 'red!important',
    },
  },
  BreakButton: {
    // marginLeft: '10px',
    height: '36px',
    border: '2px solid #0c82da',
    borderRadius: '50px',
    width: '130px',
    paddingInlineStart: '10px',
    paddingTop: '6px',
    backgroundColor: '#ffffff!important',
    '&:before, &:after': {
      borderBottom: 'none!important',
    },
    breakActive: {
      backgroundColor: "#e3f2fd",     
      color: "#1976d2",              
      fontWeight: "bold",
      borderRadius: "6px",
      border: "1px solid #1976d2",
    },
        '& $select': {
      backgroundColor: 'red!important',
    },
    [theme.breakpoints.down("md")]: {
      height: '30px',
    },
  },
  GatewayButton: {
    marginInlineStart: '10px',
    height: '36px',
    border: '2px solid #0c82da',
    borderRadius: '50px',
    paddingInlineStart: '10px',
    // paddingTop: '6px',
    backgroundColor: '#ffffff!important',
    '&:before, &:after': {
      borderBottom: 'none!important',
    },
    '& $select': {
      backgroundColor: 'red!important',
    },
    /* Jatin Sir CSS*/
    [theme.breakpoints.down("md")]: {
      height: '30px',
    },
  },
  selectsParentDiv : {
    display: "flex",
    alignItems: "center",
    gap: "0.625rem",
    transition: 'all 0.2s ease',
    [theme.breakpoints.down("md")]: {
      position: "absolute",
      top: "0.5rem",
      insetInlineEnd: "0.5rem"
    },
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      background: "#fff",
      flexDirection: "column",
      top: "70px",
      width: "100%",
      insetInlineEnd: "0",
      padding: "1rem",
      boxShadow: "0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
    },
  },
  hideSelectParent: {
    [theme.breakpoints.down("xs")]: {
    height: "0",
    padding: "0",
    overflow: "hidden"
  },
  },
  toggleSelectsMobile: {
    display: "none",
    [theme.breakpoints.down("xs")]: {
      display: "inline-flex",
    },
  },
  toggleSidbarBtn: {
    display: "none",
    [theme.breakpoints.down("xs")]: {
      display: "inline-flex",
    },
  },
  iconsParentDiv: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    marginInlineStart: "10px",
    [theme.breakpoints.down("xs")]: {
      gap: "0.30rem",
    },
    /* End Here */
  },
  ML20: {
    marginInlineStart: '20px',
  },

  ReadyButton: {
    marginInlineStart: "10px",
    color: "#0c82da",
    height: "36px",
    border: "2px solid #0c82da",
    borderRadius: "50px",
    width: "130px",
    fontSize: "1rem",
    textTransform: "capitalize",
    backgroundColor: "#ffffff!important",
    "&:hover": {
      backgroundColor: "#0c82da!important",
      color: "white!important",
    },
  },

}));
